import { Button, Image, Text, Link } from "@aws-amplify/ui-react";
import { I18n } from "aws-amplify/utils";
import React, { useContext, useEffect, useState } from "react";
import { signOut } from "aws-amplify/auth";
import { Context } from "../contexts/context";
import BasicLayout from "../components/basicLayout";
import { fetchAuthSession } from "aws-amplify/auth";
import {
	buildPathWithAuthRedirect,
	getAuthRedirectParams,
	redirectWithAuthTokens,
} from "../utils/authRedirect";
import {
	clearStoredAuthData,
	getStoredAuthData,
} from "../utils/authStorage";

const UserSummary = ({ forceRefreshAuthSession }) => {
	const { user } = useContext(Context);
	const [authData, setAuthData] = useState(null);
	const [links, setLinks] = useState([]);
	const { redirectUri, state } = getAuthRedirectParams();

	useEffect(() => {
		async function fetchSession() {
			try {
				const session = await fetchAuthSession({
					forceRefresh: forceRefreshAuthSession,
				});
				setAuthData(await getStoredAuthData(session));
			} catch (error) {
				setAuthData(await getStoredAuthData());
			}
		}

		fetchSession();
	}, [forceRefreshAuthSession]);

	useEffect(() => {
		if (!authData?.idToken) {
			return;
		}

		const tokenPayload = JSON.parse(atob(authData.idToken.split(".")[1]));

		setLinks(tokenPayload["cognito:groups"] ?? []);

		redirectWithAuthTokens({
			redirectUri,
			state,
			idToken: authData.idToken,
			accessToken: authData.accessToken,
			refreshToken: authData.refreshToken,
		});
	}, [authData, redirectUri, state]);

	const availablePoints = {
		accesso_certificati: (
			<Link
				href={I18n.get("Account activation success portale link")}
				style={{
					display: "flex",
					padding: "8px",
					gap: "8px",
					fontWeight: "600",
					color: "#4A5C7F",
					border: "1px solid #BFD5FE",
					backgroundColor: "#DBE7FE",
					borderRadius: "8px",
				}}
			>
				<Image src={"favicon.ico"} alt="favicon" width={24} height={24}></Image>
				{I18n.get("Account activation success portale label")}
			</Link>
		),
		accesso_documentale: (
			<Link
				href={I18n.get("Account activation success portale link")}
				style={{
					display: "flex",
					padding: "8px",
					gap: "8px",
					fontWeight: "600",
					color: "#4A5C7F",
					border: "1px solid #BFD5FE",
					backgroundColor: "#DBE7FE",
					borderRadius: "8px",
				}}
			>
				<Image src={"favicon.ico"} alt="favicon" width={24} height={24}></Image>
				{I18n.get("Account activation success portale label")}
			</Link>
		),
		accesso_www: (
			<Link
				href={
					I18n.get("Account activation success website link") +
					"?id_token=" +
					authData?.idToken
				}
				style={{
					display: "flex",
					padding: "8px",
					gap: "8px",
					fontWeight: "600",
					color: "#4A5C7F",
					border: "1px solid #BFD5FE",
					backgroundColor: "#DBE7FE",
					borderRadius: "8px",
				}}
			>
				<Image src={"favicon.ico"} alt="favicon" width={24} height={24}></Image>
				{I18n.get("Account activation success website label")}
			</Link>
		),
		accesso_cosmoclub: (
			<Link
				href={I18n.get("Account activation success cosmoclub link")}
				style={{
					display: "flex",
					padding: "8px",
					gap: "8px",
					fontWeight: "600",
					color: "#4A5C7F",
					border: "1px solid #BFD5FE",
					backgroundColor: "#DBE7FE",
					borderRadius: "8px",
				}}
			>
				<Image src={"favicon.ico"} alt="favicon" width={24} height={24}></Image>
				{I18n.get("Account activation success cosmoclub label")}
			</Link>
		),
		accesso_acquacalda: (
			<Link
				href={I18n.get("Account activation success acquacalda link")}
				style={{
					display: "flex",
					padding: "8px",
					gap: "8px",
					fontWeight: "600",
					color: "#4A5C7F",
					border: "1px solid #BFD5FE",
					backgroundColor: "#DBE7FE",
					borderRadius: "8px",
				}}
			>
				<Image src={"favicon.ico"} alt="favicon" width={24} height={24}></Image>
				{I18n.get("Account activation success acquacalda label")}
			</Link>
		),
		accesso_ricambi: (
			<Link
				href={I18n.get("Account activation success ricambi link")}
				style={{
					display: "flex",
					padding: "8px",
					gap: "8px",
					fontWeight: "600",
					color: "#4A5C7F",
					border: "1px solid #BFD5FE",
					backgroundColor: "#DBE7FE",
					borderRadius: "8px",
				}}
			>
				<Image src={"favicon.ico"} alt="favicon" width={24} height={24}></Image>
				{I18n.get("Account activation success ricambi label")}
			</Link>
		),
	};

	return (
		<BasicLayout>
			<div
				style={{
					display: "flex",
					flexDirection: "column",
					alignItems: "stretch",
				}}
			>
				<Text marginBottom={"20px"} textAlign={"center"}>
					{`${I18n.get("Profile hello")} `}
					<b>{user?.email}</b>
					{"!"}
					<br></br>
				</Text>
				{redirectUri && (
					<Text marginBottom={"20px"} textAlign={"center"}>
						{I18n.get("Profile redirecting")}
					</Text>
				)}
				<Text
					as="p"
					fontSize="16px"
					fontWeight="500"
					lineHeight="24px"
					textAlign={"center"}
					color="#4A5C7F"
					maxWidth="350px"
					marginInline="auto"
					dangerouslySetInnerHTML={{
						__html:
							links?.length > 0
								? I18n.get("Profile description")
								: I18n.get("Account activation success description"),
					}}
				></Text>
				{links?.length > 0 && (
					<ul
						style={{
							listStyleType: "none",
							padding: 0,
							marginBottom: "16px",
							display: "flex",
							alignItems: "stretch",
							flexDirection: "column",
							gap: "8px",
						}}
					>
						{links?.map((link) => {
							if (!availablePoints[link]) return null;
							return <li key={link}>{availablePoints[link]}</li>;
						})}
					</ul>
				)}
				<Button
					style={{
						width: "fit-content",
						margin: "16px auto 0 auto",
					}}
					onClick={async () => {
						await signOut();
						await clearStoredAuthData();
						window.location.href = buildPathWithAuthRedirect("/", {
							redirectUri,
							state,
						});
					}}
				>
					Logout
				</Button>
			</div>
		</BasicLayout>
	);
};

export default UserSummary;
